import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Image } from "react-bootstrap";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Component
import Icon from "../Icon";
import Color from "../../assets/color";

class ModalDeliveryOperationHour extends Component {
  _hideModal = () => {
    this.props.onHideDeliveryOperationHourAlert();
  };

  render() {
    const { deliveryOperationHourAlertVisible, riderAvailability } = this.props;

    return (
      <Modal
        size="xs"
        show={deliveryOperationHourAlertVisible}
        onHide={this._hideModal}
        centered={true}
        className="modal-delivery-operation-hour"
        backdrop="static"
      >
        <div className="inner-container">
          <div className="position-relative text-right">
            <div className="btn-close" onClick={this._hideModal}>
              <Icon
                type="custom"
                name="closecircle"
                color={Color.black}
                size={30}
              />
            </div>
          </div>

          <Image
            className="w-100 h-100"
            src={require("./../../assets/img/delivery-temporary-closed.png")}
          />

          <h3>Delivery Operation Hours</h3>

          <p>{riderAvailability.message} </p>
        </div>
        <Modal.Footer>
          <div className="d-flex">
            <Button
              variant="primary"
              className="ml-auto"
              onClick={() => this._hideModal()}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalDeliveryOperationHour.propTypes = {
  deliveryOperationHourAlertVisible: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    deliveryOperationHourAlertVisible:
      state.App.deliveryOperationHourAlertVisible,
    riderAvailability: state.Order.riderAvailability
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHideDeliveryOperationHourAlert: () =>
      dispatch(actions.hideDeliveryOperationHourAlert())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalDeliveryOperationHour);
